<template>
  <div class="prompt">
    <div class="question">{{ prompt.reader }}</div>
    <div class="answer">
      <div v-if="prompt.type === 'open'">
        <div class="answer-open">{{ answer }}</div>
      </div>
      <div v-if="prompt.type === 'list'">
        <div class="list-item" v-for="(i, name) in answer">&bull; &nbsp; {{ name }}</div>
      </div>
      <div v-if="prompt.type === 'custom_list'">
        <template v-for="name in answer">
          <div class="list-item" v-if="name">&bull; &nbsp; {{ name }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SummaryPrompt",
  props: ["prompt", "answer"],
  data: function() {
    return {};
  },
  computed: {
    imageUrl: function() {
      return process.env.VUE_APP_BOOK_IMAGES_PATH + this.book.id + ".jpg";
    }
  },
  created() {
    // console.log("SummaryPrompt", this.prompt, this.answer);
  }
};
</script>

<style lang="scss" scoped>
.prompt {
  padding-bottom: 20px;
  font-family: $font-family;
}

.question {
  padding: 0.5em 0;
  font-size: 14.5pt;
  font-weight: 700;
  color: $color-blue;
}

.answer {
  padding-right: 60px;
  font-size: 13.5pt;
  line-height: 1.65em;
  font-weight: 500;
  text-align: left;
}

.answer-open {
}

.list-item {
  padding: 0.25em 1em;
  font-size: 14pt;
}

@media (max-width: 1024px) {
  .answer {
    padding-right: 0px !important;
  }
}
</style>


